<template>
  <div>
    <div>
      <div v-show="isOpen" :key="name">
        <div if="$slots.menu">
          <slot name="menu"></slot>
        </div>
        <div if="$slots.websiteWrapper">
          <slot name="websiteWrapper"></slot>
        </div>
        <div if="$slots.content">
          <slot name="content"></slot>
        </div>
        <div if="$slots.right">
          <slot name="right"></slot>
        </div>
        <div if="$slots.rightWithOutHelp">
          <slot name="rightWithOutHelp"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Types as TypesApplication} from "@/store/modules/application";

export default {
  name: "TabPage",
  props: {
    menu: { type: String, required: true },
    name: { type: String, required: true },
    page: { type: String, required: true },
  },
  data: () => ({

  }),
  computed: {

    isCol1AndCol2Visible() {
      return (
        this.$slots.content &&
        (this.$store.state.application.helpIsVisible ||
          this.$slots.rightWithOutHelp ||
          this.$slots.rightWithOutHelpAndCard)
      )
    },
    isOnlyCol1Visible() {
      return (
        !this.$store.state.application.helpIsVisible &&
        this.$slots.content &&
        !this.$slots.rightWithOutHelp &&
        !this.$slots.rightWithOutHelpAndCard
      )
    },
    isCol1AndCol2aVisible() {
      return (
        this.$slots.content &&
        !this.$slots.rightWithOutHelp &&
        !this.$slots.rightWithOutHelpAndCard &&
        this.$store.state.application.helpIsVisible
      )
    },
    isCol1AndCol2bVisible() {
      return this.$slots.content && (this.$slots.rightWithOutHelp || this.$slots.rightWithOutHelpAndCard)
    },
    isOpen() {
      return this.page === this.name
    },
    isHelpVisible() {
      return this.$store.state.application.helpIsVisible
    },
  },
  methods: {
    hideHelp() {
      this.$store.dispatch(TypesApplication.actions.UPDATE_HELP_VISIBILITY, false)
    },
  }
}
</script>
